import { PlusOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import dayjs from "dayjs"
import React from "react"

import type { CalendarModalData } from "../../redux/calendar.types.ts"

const { Title, Text } = Typography

interface CalendarHeaderProps {
  createAllowed?: boolean
  onSetModalData: (data: CalendarModalData | null) => void
}

export function CalendarHeader({
  createAllowed,
  onSetModalData
}: CalendarHeaderProps) {
  const onOpenAddModal = () => {
    const today = dayjs.tz()

    onSetModalData({
      date: today,
      start_at: null,
      end_at: null
    })
  }

  return (
    <div className="flex lg:items-center gap-3 max-lg:flex-col justify-between">
      <Flex vertical>
        {/*<CalendarOutlined style={{ fontSize: "24px", color: "#2563eb" }} />*/}
        <Title level={2} className={"text-start mb-0"}>
          🗓 Calendar & Appointments
        </Title>
        <Text type={"secondary"}>
          Manage lead meetings, site visits, and follow-ups
        </Text>
      </Flex>

      {createAllowed && (
        <Button
          type={"primary"}
          onClick={onOpenAddModal}
          icon={<PlusOutlined />}
        >
          Event
        </Button>
      )}
    </div>
  )
}
